<script>
import Service from '../../services/clearance-document';
import config from '../../common/genericPanelConf';

import Utils from '../../common/Utils';

import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Toolbar from 'primevue/toolbar';
import Fieldset from 'primevue/fieldset';
import Textarea from 'primevue/textarea';

import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';
import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    InputText,
    InputNumber,
    Toolbar,
    GenericDateTimeMaskV2,
    Fieldset,
    GenericCustomMasterDataAutocompleteV2,
    GenericBooleanDropdown,
    Textarea
},
  data(){
    return {
      id: this.$route.query.id,
      submitted: false,
      data: {},
      fieldset: {},
    }
  },
  validations(){
    let validations = {}

    if(this.config){
      Object.entries(this.config).forEach(element => {
        validations[element[0]] = {};
        Object.entries(element[1]).forEach(field => {
          if(field[1].validations) {
            validations[element[0]][field[0]] = {};
          }
          if(field[1].validations?.maxLength) {
            validations[element[0]][field[0]].maxLength = maxLength(field[1].validations.maxLength);
          }
          if(field[1].validations?.required) {
            validations[element[0]][field[0]].required = required;
          }
          if(field[1].validations?.minValue) {
            validations[element[0]][field[0]].minValue = minValue(field[1].validations.minValue);
          }
        })
      });
    }
    return validations;
  },
  created(){
    this.config = config.getConfiguration('ClearanceDocument')['DAA'];
  },
  computed: {
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    },
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'issueOfDocuments.DAA.page_title');
    this.load();
  },
  watch: {

  },
  methods: {
    load(){
      Service.getClearanceDocumentDAA(this.id, ({success, data}) => {
        if(success){
          this.data = data;
          Object.entries(this.config).forEach(([key, value]) => {
            value?.category && ((this.fieldset[value.category] || (this.fieldset[value.category] = {})) && (this.fieldset[value.category][key] = data[key]));
          });
        }
      })
    },
    updateDocument(){
      this.submitted = true;
      Service.updateClearanceDocumentDAA(this.data, ({success, message}) => {
        if(success){
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        }else{
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    sendEAd(){
      Service.sendClearanceDocumentDAA({id: this.id}, ({success, message}) => {
        if(success){
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        }else{
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    assignLocalNumber(){
      if (this.data.eaadLocalReferenceNumber) {
        this.$confirm.require({
        target: 'assignNewDocumentNumber',
        message: this.$t('messages.assignNewDocumentNumber'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.assignClearanceDocumentDAALocalNumber({id: this.id}, (response) =>{
            if(response.success){
              this.$confirm.close();
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
              this.load();
            }
            else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          })
        },
        reject: () => {
            this.$confirm.close();
        }});
      } else {
        Service.assignClearanceDocumentDAALocalNumber({id: this.id}, (response) =>{
          if(response.success){
            this.$confirm.close();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000});
            this.load();
          }
          else{
            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    getARC(){
      Service.getClearanceDocumentARC({id: this.id}, ({success, message}) => {
        if(success){
          this.load();
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        }else{
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    }
  }
}

</script>

<template> 
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 field">
          <Toolbar>
            <template #start>
              <Button :label="$t('btn.save')" icon="pi pi-save" class="mr-2" @click="updateDocument"/>
              <Button :label="$t('issueOfDocuments.DAA.sendEAD')" icon="pi pi-send" class="mr-2" @click="sendEAd"/>
              <Button :label="$t('issueOfDocuments.DAA.getArc')" icon="pi pi-cloud-download" class="mr-2" @click="getARC"/>
              <Button :label="$t('btn.assignLocalNumber')" icon="pi pi-ticket" class="mr-2" @click="assignLocalNumber"/>
            </template>
          </Toolbar>
        </div>
        <Fieldset v-for="field in Object.keys(fieldset)" :key="field" :legend="$t('issueOfDocuments.DAA.' + field)" class="col-12 my-2">
          <div class="grid">
          <template v-for="key in Object.keys(fieldset[field])" :key="key">
            <template v-if="!config[key]?.hidden">
              <div v-if="config[key]?.type === 'text'" class="col-12 lg:col-3 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  :for="key"
                  v-tooltip="$t('issueOfDocuments.DAA.' + key)">
                  {{ $t('issueOfDocuments.DAA.' + key) }}
                </label>
                <InputText 
                  :class="{'p-invalid':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  :disabled="config[key].readonly"
                  :id="key"
                  type="text"
                  v-model="data[key]"
                  class="w-full p-inputtext-sm m-1" />
                <div v-if="(v$.data?.[key] && v$.data?.[key].$invalid && submitted) || v$.data?.[key] && v$.data?.[key].$pending.$response">
                  <small class="p-error" v-for="error in v$.data?.[key] && v$.data?.[key].$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div v-if="config[key]?.type === 'number' || config[key]?.type === 'decimal'" class="col-12 lg:col-3 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-tooltip="$t('issueOfDocuments.DAA.' + key)"
                  :for="key">
                  {{ $t('issueOfDocuments.DAA.' + key) }}
                </label>
                <InputNumber 
                  :class="{'p-invalid':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  :disabled="config[key].readonly"
                  :id="key"
                  :minFractionDigits="config[key].decimals ?? 0"
                  :maxFractionDigits="config[key].decimals ?? 0"
                  v-model="data[key]"
                  class="w-full m-1" />
                <div v-if="(v$.data?.[key] && v$.data?.[key].$invalid && submitted) || v$.data?.[key] && v$.data?.[key].$pending.$response">
                  <small class="p-error" v-for="error in v$.data?.[key] && v$.data?.[key].$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div v-if="config[key]?.type === 'boolean'" class="col-12 lg:col-3 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-tooltip="$t('issueOfDocuments.DAA.' + key)"
                  :for="key">
                  {{ $t('issueOfDocuments.DAA.' + key) }}
                </label>
                <GenericBooleanDropdown
                  :class="{'p-invalid':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  :id="key" 
                  v-model="data[key]" 
                  :disabled="config[key].readonly"
                  class="w-full m-1"
                />
                <div v-if="(v$.data?.[key] && v$.data?.[key].$invalid && submitted) || v$.data?.[key] && v$.data?.[key].$pending.$response">
                  <small class="p-error" v-for="error in v$.data?.[key] && v$.data?.[key].$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div v-if="config[key]?.type === 'textarea'" class="col-12 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-tooltip="$t('issueOfDocuments.DAA.' + key)"
                  :for="key">
                  {{ $t('issueOfDocuments.DAA.' + key) }}
                </label>
                <Textarea
                  :class="{'p-invalid':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  :id="key" 
                  v-model="data[key]" 
                  :disabled="config[key].readonly"
                  class="w-full m-1"
                />
                <div v-if="(v$.data?.[key] && v$.data?.[key].$invalid && submitted) || v$.data?.[key] && v$.data?.[key].$pending.$response">
                  <small class="p-error" v-for="error in v$.data?.[key] && v$.data?.[key].$silentErrors" :key="error.$validator">
                      {{error.$message}}
                  </small>
                </div>
              </div>
              <div v-if="config[key]?.type === 'comboKey'" class="col-12 lg:col-3 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-tooltip="$t('issueOfDocuments.DAA.' + config[key]?.label)"
                  :for="key">
                  {{ $t('issueOfDocuments.DAA.' + config[key]?.label) }}
                </label>
                <GenericCustomMasterDataAutocompleteV2
                  v-model="data[key]"
                  :name="key"
                  :refLabel="key"
                  :api="config[key].api"
                  :format="{ label: 'label', value: 'code' }"
                  sortField="Code" />
              </div>
              <div v-if="config[key]?.type === 'date'" class="col-12 lg:col-3 field" >
                <label :class="{'p-error':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-tooltip="$t('issueOfDocuments.DAA.' + key)"
                  :for="key">{{ $t('issueOfDocuments.DAA.' + key) }}
                </label>
                <GenericDateTimeMaskV2 
                  :class="{'p-invalid':v$.data?.[key] && v$.data?.[key].$invalid && submitted}"
                  v-model="data[key]"
                  :readonly="config[key].readonly"
                  inputClass="w-full" />
                  <div v-if="(v$.data?.[key] && v$.data?.[key].$invalid && submitted) || v$.data?.[key] && v$.data?.[key].$pending.$response">
                    <small class="p-error" v-for="error in v$.data?.[key] && v$.data?.[key].$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                  </div>
              </div>
            </template>
          </template> 
        </div>
        </Fieldset>
      </div>
    </div>
  </main>
</template>


<style scoped>

.field > label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  max-width: fit-content;
}

</style>